module.exports = __webpack_public_path__ + "img/bgD.a6e327fd.jpg";